import { Button, Form, Input, Modal, Select } from "antd";
import { useEffect } from "react";
import { PositionLevel } from "../../constants/common";
import { useCreatePosition } from "../../query/DepartmentQuery";
import { notify } from "../../utils/toast";

interface ModalAddPositionProps {
  open: boolean;
  departmentId: number;
  departmentName: string;
  onCancel: () => void;
}

const ModalAddPosition = ({
  open,
  departmentId,
  departmentName,
  onCancel,
}: ModalAddPositionProps) => {
  const [form] = Form.useForm();
  const createPosition = useCreatePosition();

  useEffect(() => {
    if (open) {
      form.resetFields();
    }
  }, [open, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      await createPosition.mutateAsync({
        ...values,
        departmentId,
      });
      notify.success("Thêm vị trí thành công");
      form.resetFields();
      onCancel();
    } catch (error) {
      notify.error("Thêm vị trí thất bại");
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      title={`Thêm vị trí mới cho phòng ${departmentName}`}
      width={600}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Hủy
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={createPosition.isPending}
          onClick={handleSubmit}
        >
          Thêm
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical" className="mt-4">
        <Form.Item
          label="Mã vị trí"
          name="positionCode"
          rules={[{ required: true, message: "Vui lòng nhập mã vị trí" }]}
        >
          <Input placeholder="VD: POS_001" />
        </Form.Item>
        <Form.Item
          label="Tên vị trí"
          name="positionTitle"
          rules={[{ required: true, message: "Vui lòng nhập tên vị trí" }]}
        >
          <Input placeholder="VD: Quản lý kho" />
        </Form.Item>
        <Form.Item
          label="Cấp bậc"
          name="level"
          rules={[{ required: true, message: "Vui lòng chọn cấp bậc" }]}
        >
          <Select placeholder="Chọn cấp bậc">
            {PositionLevel.map((level) => (
              <Select.Option key={level.value} value={level.value}>
                {level.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Mô tả" name="description">
          <Input.TextArea placeholder="Mô tả chi tiết vị trí" rows={3} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalAddPosition;
